import { DASHBOARD } from 'src/modules/constants';
import { Module, ModulesList } from 'src/modules/types';
import Dashboard from './index';
import DashboardThunk from './thunk';
import { start, steps } from './tour';

const module: ModulesList = {
  [DASHBOARD]: {
    path: '/dashboard/:playgroundType',
    component: Dashboard,
    thunk: DashboardThunk,
    helpTour: { steps, start },
  } as Module,
};

export default module;
